import script from "./apply.vue?vue&type=script&lang=ts&setup=true"
export * from "./apply.vue?vue&type=script&lang=ts&setup=true"

import "./apply.vue?vue&type=style&index=0&id=25d2f0cd&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d2f0cd"]])

export default __exports__